import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["content", "onOk", "okText", "cancelText", "closable", "cancelshow", "okshow", "modalStyle", "cnode", "footerStyle", "triggerEvent"];
import React from 'react';
// import { createRoot } from 'react-dom/client';

// import * as ReactDOM from 'react-dom';

import { StaticModal as Modal } from './Modal';
import { Button } from '../button';
import ReactDOMType from '../utils/reactRequire';
;
export var ModalRender = function ModalRender(props) {
  var content = props.content,
    onOk = props.onOk,
    _props$okText = props.okText,
    okText = _props$okText === void 0 ? 'OK' : _props$okText,
    _props$cancelText = props.cancelText,
    cancelText = _props$cancelText === void 0 ? 'Cancel' : _props$cancelText,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$cancelshow = props.cancelshow,
    cancelshow = _props$cancelshow === void 0 ? true : _props$cancelshow,
    _props$okshow = props.okshow,
    okshow = _props$okshow === void 0 ? true : _props$okshow,
    _props$modalStyle = props.modalStyle,
    modalStyle = _props$modalStyle === void 0 ? {
      width: '33.75rem'
    } : _props$modalStyle,
    cnode = props.cnode,
    footerStyle = props.footerStyle,
    triggerEvent = props.triggerEvent,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _React$useState = React.useState(false),
    visible = _React$useState[0],
    setvisible = _React$useState[1];
  var destroy = function destroy() {
    setvisible(false);
    setTimeout(function () {
      document.body && document.body.removeChild(cnode);
    }, 500);
  };
  React.useEffect(function () {
    setTimeout(function () {
      setvisible(true);
    }, 100);
  }, []);
  var close = function close() {
    if (props.onNo) {
      !props.onNo(props) && destroy();
      return;
    }
    destroy();
  };
  var ok = function ok() {
    if (props.onOk) {
      !props.onOk(props) && destroy();
      return;
    }
    destroy();
  };
  var footerCont = (cancelshow || okshow) && /*#__PURE__*/React.createElement(React.Fragment, null, cancelshow && /*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    onClick: function onClick() {
      close();
    }
  }, cancelText), okshow && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      ok();
    }
  }, okText));
  return /*#__PURE__*/React.createElement(Modal, _extends({
    onCancel: function onCancel() {
      close();
    },
    footer: footerCont,
    closable: closable,
    visible: visible,
    modalStyle: modalStyle,
    footerStyle: footerStyle,
    isDynamic: true,
    triggerEvent: triggerEvent
  }, otherProps), content);
};
export var confirm = function confirm(props) {
  var cnode = document.createElement('div');
  document.body && document.body.appendChild(cnode);
  // const renderDom = createRoot(cnode);
  var render = function render() {
    // ReactDOM.render(<ModalRender cnode={cnode} {...props} />, cnode)
    ReactDOMType(cnode, /*#__PURE__*/React.createElement(ModalRender, _extends({
      cnode: cnode
    }, props)));
  };
  var update = function update(curProps) {
    props = _extends({}, props, curProps);
    render();
  };
  render();
  return {
    update: update
  };
};